import { API_URL } from "config";
import Http from "util/https";
import { StoreTargetApiParams, TargetStore } from "../types";

/**
 * 企業用店舗選択肢取得Api
 * @returns レスポンスデータ
 */
export default async function getStoreDataCompanyApi(): Promise<TargetStore[]> {
  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/order/company/stores`;
  const res = await http.get<{ stores: TargetStore[] }>(url);
  console.log(res);

  return res.data.stores;
}
